module.exports = __webpack_public_path__ + "static/media/icono-postres-cartedor-ar-ene24.7180b45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-postres-cartedor-ar-ene24.png
// module id = 326
// module chunks = 0